import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useFilterStore } from "@faire/retailer-visitor-shared/components/Filters/useFilterStore";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { ILayoutElement } from "@faire/web-api--source/indigofair/data/ILayoutElement";
import React from "react";
import styled from "styled-components";
import { FilterInfoSticky } from "@faire/retailer/components/Filters/FilterInfoSticky";
import { FilterName } from "@faire/retailer/components/Filters/FilterName";
import { NoResultsContainer } from "@faire/retailer/components/NoResults";
import { useCategoryPageScroll } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/CategoryPageShareables/hooks/useCategoryPageScroll";
import { LoggedOutCategoryPageHelmet } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/components/LoggedOutCategoryPageAboveFold/LoggedOutCategoryPageHelmet";
import { LoggedOutCategoryPageFilterSidebar } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/components/LoggedOutCategoryPageFilterAndResults/LoggedOutCategoryPageFilterSidebar";
import { LoggedOutCategoryPageProductList } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/components/LoggedOutCategoryPageFilterAndResults/LoggedOutCategoryPageProductList";
import { LoggedOutCategoryPageLayoutElements } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/components/LoggedOutCategoryPageLayoutElements/LoggedOutCategoryPageLayoutElements";
import { useLoggedOutCategoryPageLayoutElementsIsLoading } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/DataFetching/useLoggedOutCategoryPageLayoutElementsIsLoading";
import { useLoggedOutCategoryPageisLoadedAndHasNoResults } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/hooks/useLoggedOutCategoryPageisLoadedAndHasNoResults";
import { LoggedOutCategoryPageWrapper } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/styles/LoggedOutCategoryPageStyles";
import { LoggedOutCategoryPageHeroBannerSkeleton } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/CategoryPageLoadingSkeleton/LoggedOutCategoryPageLoadingSkeleton";
export var LoggedOutCategoryPageAboveFold = function(param) {
    var categoryPageLoadTimingRef = param.categoryPageLoadTimingRef;
    var isLoadedAndHasNoResults = useLoggedOutCategoryPageisLoadedAndHasNoResults();
    var scrollRef = useCategoryPageScroll().scrollRef;
    var _useFilterStore = useFilterStore([
        "activeFilterCount"
    ]), clearAllFilters = _useFilterStore.clearAllFilters, activeFilterCount = _useFilterStore.data.activeFilterCount;
    var isLayoutElementsLoading = useLoggedOutCategoryPageLayoutElementsIsLoading();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(LoggedOutCategoryPageHelmet, {}),
            isLayoutElementsLoading ? /*#__PURE__*/ _jsx(LoggedOutCategoryPageHeroBannerSkeleton, {}) : /*#__PURE__*/ _jsx(LoggedOutCategoryPageLayoutElements, {
                placement: ILayoutElement.Placement.ABOVE_TITLE
            }),
            /*#__PURE__*/ _jsxs(LoggedOutCategoryPageWrapper, {
                children: [
                    /*#__PURE__*/ _jsx(LoggedOutCategoryPageLayoutElements, {
                        placement: ILayoutElement.Placement.BELOW_BREADCRUMB
                    }),
                    /*#__PURE__*/ _jsxs(Row, {
                        children: [
                            /*#__PURE__*/ _jsx(StyleLoggedOutCategoryPageFilterSidebar, {}),
                            /*#__PURE__*/ _jsxs(Column, {
                                style: {
                                    width: "100%"
                                },
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        ref: scrollRef
                                    }),
                                    isLoadedAndHasNoResults ? /*#__PURE__*/ _jsx(NoResultsContainer, {
                                        showProductFirstResults: true,
                                        hasFiltersApplied: activeFilterCount > 0,
                                        onClearFilters: clearAllFilters,
                                        divRef: categoryPageLoadTimingRef
                                    }) : /*#__PURE__*/ _jsxs(_Fragment, {
                                        children: [
                                            /*#__PURE__*/ _jsx(FilterInfoSticky, {
                                                name: FilterName.LOGGED_OUT_CATEGORY,
                                                shouldNotShowFilterCollapsePillOnTabletAndBelow: true
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                ref: categoryPageLoadTimingRef,
                                                style: {
                                                    paddingTop: getSpacing("1x")
                                                },
                                                children: /*#__PURE__*/ _jsx(LoggedOutCategoryPageProductList, {})
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var StyleLoggedOutCategoryPageFilterSidebar = styled(LoggedOutCategoryPageFilterSidebar).withConfig({
    componentId: "sc-d3ccf813-0"
})([
    "padding-top:",
    ";"
], getSpacing("2x"));
